/*
	支払方法管理画面
	定期購読一覧取得　表示画面
*/

import React, { memo } from 'react';
// import classes from './subscription-list-table.module.scss';
import { SubscriptionListTableDetail } from 'components/molecules/subscription-list-table-detail/SubscriptionListTableDetail';
import { PeriodicPaymentToken } from 'requests/RequestPeriodicPayment';

type Props = {
	periodicPaymentList: PeriodicPaymentToken[] | [];
	onClickEvent: (index: number) => void;
};
export const SubscriptionListTable = memo((props: Props) => {
	const { periodicPaymentList, onClickEvent } = props;

	// ------定数 state------
	const tableColumnList = ['サービス名', '初回決済日', '最終決済日'];
	const tableKeyList = ['site_name', 'first_capture_date', 'last_capture_date'];

	return (
		<SubscriptionListTableDetail
			headerTitle={'定期購読一覧'}
			tableColumnList={tableColumnList}
			tableKeyList={tableKeyList}
			periodicPaymentList={periodicPaymentList}
			onClickEvent={onClickEvent}
		/>
	);
});
